import React, { useEffect, useState } from "react";
import apiClient from "../utils/axios";
import { MANAGER } from "../config/api";
import toast from "react-hot-toast";

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch notifications on page load
  useEffect(() => {
    fetchNotifications();
  }, []);

  // ✅ Function to get notifications from backend
  const fetchNotifications = async () => {
    try {
      const { data } = await apiClient.get(MANAGER.NOTIFICATIONS);
      if (data.success) {
        setNotifications(data.notifications || []);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
      toast.error(err.response?.data?.message || err.message || "Failed to fetch notifications");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Function to update seen status (received / not received)
  const handleStatusUpdate = async (id, seenValue) => {
    try {
      const { data } = await apiClient.put(MANAGER.UPDATE_NOTIFICATION(id), {
        seen: seenValue,
      });

      if (data.success) {
        toast.success("Notification status updated");
        setNotifications((prev) =>
            prev.filter((n) => n._id !== id)
        );
      }
    } catch (err) {
      console.error("Error updating status:", err);
      toast.error(err.response?.data?.message || err.message || "Failed to update notification status");
    }
  };

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Loading...</p>;
  }

  return (
    <div style={styles.page}>
      <h2 style={styles.heading}>Notifications</h2>

      <div style={styles.container}>
        {notifications.length === 0 ? (
          <p style={{ color: "#bbb" }}>No notifications found</p>
        ) : (
          notifications.map((n) => (
            <div key={n._id} style={styles.card}>
              <h3 style={styles.title}>
                {n.type === "cash_payment"
                  ? "💰 Cash Payment"
                  : n.type === "order_update"
                  ? "📦 Order Update"
                  : "⚙️ System Message"}
              </h3>
              <p style={styles.message}>{n.message}</p>

              <div style={styles.btnGroup}>
                <button
                  style={{
                    ...styles.button,
                    backgroundColor: "#28a745",
                    opacity: n.seen ? 0.7 : 1,
                  }}
                  onClick={() => handleStatusUpdate(n._id, true)}
                >
                  Received
                </button>
                <button
                  style={{
                    ...styles.button,
                    backgroundColor: "#dc3545",
                    opacity: !n.seen ? 0.7 : 1,
                  }}
                  onClick={() => handleStatusUpdate(n._id, false)}
                >
                  Not Received
                </button>
              </div>

              <p style={styles.status}>
                Status:{" "}
                <span
                  style={{
                    color: n.seen ? "#28a745" : "#dc3545",
                    fontWeight: "bold",
                  }}
                >
                  {n.seen ? "Received" : "Not Received"}
                </span>
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    backgroundColor: "#121212",
    color: "#e0e0e0",
    minHeight: "100vh",
    padding: "40px 0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#00b4d8",
    fontSize: "28px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
  },
  card: {
    width: "60%",
    backgroundColor: "#1e1e2a",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    textAlign: "center",
    transition: "transform 0.2s",
  },
  title: {
    fontSize: "20px",
    color: "#fff",
    marginBottom: "8px",
  },
  message: {
    color: "#bbb",
    marginBottom: "20px",
  },
  btnGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
  },
  button: {
    border: "none",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    padding: "10px 20px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  status: {
    marginTop: "15px",
    fontSize: "16px",
  },
};

export default Notification;
